import "./App.css";
import Homepage from "./pages/Homepage";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./styles/style.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EntryPage from "./pages/EntryPage";
import { useEffect } from "react";
import RegisterUser from "./pages/RegisterUser";
import LoginPage from "./pages/LoginPage";
import NotFound from "./pages/NotFound";
import { Authentication } from "./useAuth";
import UserRoles from "./pages/UserRoles";
import { ProfilePage } from "./pages/ProfilePage";
import RegisterEntity from "./pages/RegisterEntity";
import LandingPage from "./pages/LandingPage";
import GlobalHeader from "./Components/GlobalHeader";

function App() {
  const Scroll = (props) => {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
    return props.children;
  };
  return (
    <BrowserRouter>
      <GlobalHeader />
      <ToastContainer position="bottom-center" />
      <Authentication>
        <Scroll>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            {/* <Route path="*" element={<NotFound />} /> */}
            {/* <Route path="login" element={<LoginPage />} /> */}
            <Route path="/my" element={<EntryPage />}>
              <Route path="" element={<Navigate to="home" />} />
              <Route path="home" element={<Homepage />} />
              <Route path="registerUser" element={<RegisterUser />} />
              <Route path="userRoles" element={<UserRoles />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="registerEntity" element={<RegisterEntity />} />
            </Route>
          </Routes>
        </Scroll>
      </Authentication>
    </BrowserRouter>
  );
}

export default App;
